<template>
    <div>
        <div class="login_box" v-show="showLogin">
            <div class="line">请输入欲续费的账号<input type='text' v-model="user" /></div>
            <div class="line">
                为避免续费账号填写有误，请输入密码进行验证<input type='password' v-model="password" />
                <NormalButton style='height:26px;' :theme='"blue"' :disabled='$route.name == "Preview" ?  true : false'
                    :style="'width:51px;'" @click='valid'>去验证</NormalButton>
                <a class="forget_pwd" target="_blank" :href="forgetPwdUrl">找回账号密码</a>
            </div>
        </div>
        <div class="renew_box" v-if='showRenew'>
            <div style='text-align:right;'>
                <button class="back_btn" @click='backToLogin'>继续对其它账号续费</button>
            </div>
            <h3 class="tips">{{user}}账号验证通过!</h3>
            <p style='margin-bottom:10px;'>请在下表勾选在该账号上欲续费的功能或数据授权：</p>
            <RenewAuthTable ref='authTable' @choose='tableChoose' :authData="authData" v-model="authPrice" :orderLimit='orderLimit' />
            <p v-show="selectshow || jgselectShow" style='margin-top:10px;'>请确认本次购买人身份：</p>
            <button v-show="selectshow" @click="exchange" class="arg_btn">{{argBtn}}</button>
            <div v-show="selectshow" class="argument" :class="{show: argBtn == '收起'}">
                <vue-scroll>
                    <div style='padding: 5px 10px;'>
                        <span>非专业用户是指包括1. 个人、自然人用户 2.
                            某些小型商业实体（有限责任公司、合伙、信托或法人），获得和使用市场数据（不包括任何场内交易数据），并受到下列限制的：</span><span
                            style="margin-top:15px;display: block;">非专业订阅人必须：<br>a.拥有一个活跃的期货交易账户；<br>b.是个人，自然人或小型商业实体；</span><span
                            style="margin-top:15px;display: block;">非专业用户必须不能是：<br>c.任何交易所的会员（亦不得拥有或租用任何交易所的任何一类会员资格）；<br>d.在任何证券交易所、商品交易所、期货交易所、合约市场或者任何监管机构、专业协会或经过任何的专业机构登记或获得资格认证的专业交易员或投资顾问；<br>e.作为一个机构的代表从事经济业务，银行业，投资业或其他金融活动；</span><span
                            style="margin-top:15px;display: block;">非专业用户使用信息：<br>f.仅为用户本人使用；<br>g.不应超出用户本人所能管理的资产，不能和任何第三方有任何资产的联系；</span><span
                            style="margin-top:15px;display: block;">非专业用户获取信息：<br>h.从每一经销商处获取市场资料的渠道可以有两（2）条,并且订阅人须在能将订单传送到交易所电子交易平台的设备（“订单传送设备”）上浏览市场数据。</span><span>订单传送设备：有权接收实时信息，并能够向CME
                            Globex电子交易平台传送指令的交易终端。</span><span
                            style="margin-top:15px;display: block;">不符合非专业用户资格条件的任何订阅人，均应被视为专业用户。</span><span
                            style="display: block;margin-bottom:15px;">不管本档中有何规定，在各种情况下，交易所均保留对某一订阅人是非专业用户还是专业用户作出最终认定的权利，交易所保留随时修订本政策或者终止对非专业用户减低收费标准的做法的权利。</span><span
                            style="display: block;">请选择您的类别，然后本文档将被文华财经保存，备交易所随时审查。<br>请注意，如果订阅人不再符合非专业用户的资格条件，则其必须在合理可行的范围内尽快通知文华财经。</span>
                    </div>
                </vue-scroll>
            </div>

            <div class="selectItem" v-show="selectshow" :class="{active: index == chooseIndex && chooseIndex != null}"
                @click="choose(item,index)" v-for="(item,index) in selectList" :key="index">
                <i></i>
                {{item}}
            </div>

            <p v-show='jgselectShow' style='margin-top:20px;margin-bottom:5px;'>香港数据针对个人用户和公司用户数据授权费不同</p>
            <div class="selectItem" v-show='jgselectShow'
                :class="{active: index == jgChooseIndex && jgChooseIndex != null}" @click="jgChoose(item,index)"
                v-for="(item,index) in jgSelectList" :key="'x'+index">
                <i></i>
                {{item}}
            </div>
            <template v-if="isMonthPay || isQuarterPay">
                <div class="cut-line"></div>
                <p class="little-label">支付方式:</p>
                <AuthChooseItem v-for='(item) in deadLine' :key='item.name' :name='item.name' @click='chooseLimit(item)' :selected='item.selected' :disable='item.disable ||  $route.name == "Preview"'/>
            </template>
        </div>
    </div>
</template>

<script>
    import RenewAuthTable from '@/components/RenewAuthTable'
    const triggerOnce = wh.triggerOnce()
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'renew',
        components: {
            RenewAuthTable
        },
        inject: ['renewValidCross', 'changeAuthPrice', 'buy', 'changeMainPrice','setMultipleAccounts','orderByMonth','orderByYear', 'orderByQuarter','orderByCancel','getPwdAddress','setRenewBuyValidState', 'setLoading'],
        props: {
            whProduct: {
                type: Array,
                default: () => ([])
            }
        },
        data: () => ({
            user: '',
            authData: [],
            authPrice: 0,
            showRenew: false,
            user: '',
            password: '',
            showLogin: true,
            argBtn: '根据CME关于专业和非专业用户的规定',
            chooseIndex: null,
            jgChooseIndex: null,
            selectList: ['本人确认，本人符合非专业用户资格', '本人确认，本人符合专业用户资格'],
            jgSelectList: ['本人特此确认，本人是个人用户', '本人特此确认，本人是公司用户'],
            argumentName: '根据CME关于专业和非专业用户的规定',
            jgselectShow: false,
            selectshow: false,
            deadLine: [
                {
                    name: '按年支付',
                    value: 1,
                    selected: true,
                    disable: false
                }
            ],
            price: 0,
            monthprice: 0,
            quarterprice: 0,
            isDanAuthorization: false,
            memoryAuthSelections: [],
            isMonthPay: false,
            isQuarterPay: false,
            productId: ''
        }),
        computed: {
            
            selectIds() {
                return this.showRenew ? this.$refs.authTable.selectIds : ''
            },
            forgetPwdUrl() {
                var url = this.getPwdAddress()
                if (url) {
                    return url
                } else if (this.productId == 76) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh7'
                } else if (this.productId == 1) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh8'
                } else if (this.productId == 124) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh9'
                } else if (this.productId == 125 || this.productId == 110  || this.productId == 138) {
                    url = 'https://webapi.wenhua.com.cn/AutoRegister/ForgetPwd'
                } else if (this.productId == 126 || this.productId == 128 || this.productId == 129) {
                    url = 'https://webapi.wenhua.com.cn/AutoRegister/ForgetPwdWh5'
                }
                return url
            },
            orderLimit () {
                let target = this.deadLine.find(v=>v.selected)
                if (target) {
                    return target.value
                } else {
                    return -1
                }
            },
            hasHistoryData () {
                return this.$refs.authTable.selectHistory
            }
        },
        watch: {
            authPrice: {
                handler(val) {
                    this.changeAuthPrice(val)
                },
                immediate: true
            },
            chooseIndex(val) {
                if (val != null) {
                    let data = this.$store.state.renewbuy.fetchInfo
                    data.ismajor = val
                    this.$store.commit('renewbuy/setInfo', data)
                }
            },
            jgChooseIndex(val) {
                if (val != null) {
                    let data = this.$store.state.renewbuy.fetchInfo
                    data.isjg = val
                    this.$store.commit('renewbuy/setInfo', data)
                }
            }
        },
        mounted() {
            this.setRenewBuyValidState(this.backToLogin)
            if (!this.productId) {
                this.productId = this.$route.params.id
            }
        },
        methods: {
            valid(finish) {
                var self = this
                if (/^[A-Z]+$/.test(this.user)) {
                    finish()
                    return this.$market.alert({
                        content: '账号不能包含大写字母'
                    })
                } else if (this.user == '') {
                    finish()
                    return this.$market.alert({
                        content: '请输入欲续费的账号'
                    })
                } else if (this.password == '') {
                    finish()
                    return this.$market.alert({
                        content: '请输入密码'
                    })
                }
                if (!finish) this.setLoading(true)
                this.$axios({
                    url: "/api/Wh5Order/Wh5AccountAdd?pid=129&account=" + this.user + "&identityType=1&pwd=" + this.password,
                    method: "get"
                })
                .then(async res => {
                    if (finish) {
                        finish()
                    } else {
                        this.setLoading(false)
                    }
                    
                    this.deadLine = [
                        {
                            name: '按年支付',
                            value: 1,
                            selected: true,
                            disable: false
                        }
                    ]
                    if (res.data.status) {
                        self.changeMainPrice(res.data.result.product.price)
                        self.price = res.data.result.product.price
                        res.data.result.sublist = res.data.result.sublist.filter(v=>v.sale)
                        self.$store.commit('renewbuy/setInfo', res.data)
                        renewshow()
                        function renewshow(data) {
                            self.showRenew = true
                            self.showLogin = false
                            self.renewValidCross(true) //通知上层组件，续费验证通过了
                            data = data ? data.result : res.data.result

                            data.sublist.forEach(async item => {
                                let obj = {
                                    ...item,
                                    _exist: false
                                }
                                if (item.productlink.indexOf('EUREX') >= 0 || item.productName
                                    .indexOf('香港') >= 0) {
                                    if (res.data.isjg || res.data.isjg === 0) {
                                        obj._ismajor = res.data.isjg
                                        obj._selected = true
                                    } else {
                                        obj._ismajor = null
                                        obj._selected = false
                                    }
                                } else {
                                    if (!data.ismajor && data.ismajor != 0) {
                                        obj._ismajor = null
                                        obj._selected = false
                                    } else {
                                        obj._ismajor = data.ismajor
                                        obj._selected = true
                                        //如果用户同时可以选择上海五档的两个交易所数据，那么这两个都不勾选，2021-10-8柏慧加
                                        if (item.id == 348 || item.id == 170) {
                                            obj._selected = false
                                        }
                                    }
                                }

                                self.authData.push(obj)
                            })
                            self.chooseIndex = res.data.ismajor == 1 ? 1 : 0
                            self.jgChooseIndex = res.data.isjg == 1 ? 1 : 0


                            let eurex = data.sublist.find(v => v.productlink.indexOf('EUREX') >=
                                0) //判断续费授权中是否有欧交所
                            let hk = data.sublist.find(v => v.productName.indexOf('香港') >=
                                0) //判断续费授权中是否有香港
                            if (eurex || hk) {
                                self.jgselectShow = true //有欧交所就显示个人机构的选择
                            }

                            let out = data.sublist.find(v => v.price != v.majorprice && v.productName.indexOf('香港') < 0) //判断续费授权中是否有外盘（两个价格不等）
                            if (out) {
                                self.selectshow = true //有外盘则显示专业非专业的选择
                            }
                        }

                    } else {
                        self.$market.alert({
                            content: res.data.message
                        })
                    }
                })

            },
            accountChange (val) {
                //设置父组件上的小账号值
                this.setMultipleAccounts(val)
            },
            backToLogin() {
                this.user = ''
                this.password = ''
                this.showRenew = false
                this.showLogin = true
                this.jgselectShow = false
                this.selectshow = false
                this.chooseIndex = null
                this.jgChooseIndex = null
                this.authData = []
                this.renewValidCross(false) //通知上层组件，续费验证取消
                this.setMultipleAccounts([]) //通知上层组件，重置小账号的值
                this.deadLine = [
                    {
                        name: '按年支付',
                        value: 1,
                        selected: true,
                        disable: false
                    }
                ]
                
                this.price = 0
                this.monthprice = 0
                this.isDanAuthorization = false
                this.memoryAuthSelections = []
                this.orderByCancel()
            },
            exchange() {
                if (this.argBtn == this.argumentName) {
                    this.argBtn = '收起'
                } else {
                    this.argBtn = this.argumentName
                }
            },
            choose(item, index) {
                this.chooseIndex = index
                if (index == 0) {
                    this.$refs.authTable.setUnMajorAll()
                } else if (index == 1) {
                    this.$refs.authTable.setMajorAll()
                }
            },
            jgChoose(item, index) {
                this.jgChooseIndex = index
                if (index == 0) {
                    this.$refs.authTable.setNotJg()
                } else if (index == 1) {
                    this.$refs.authTable.setJg()
                }
            },
            tableChoose(next, item, index) {
                if (this.chooseIndex == null) {
                    return this.$market.alert({
                        content: '请先在下方选择您的身份'
                    })
                }
                if (item.productlink && item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0) {
                    let selectOut = this.$refs.authTable.selectOut
                    if (selectOut.length == 1 && selectOut[0].id == item.id) {
                        this.selectshow = false
                    } else if (selectOut.length == 0 && item.price != item.majorprice) {
                        this.selectshow = true
                    }
                }
                let needJGChoose = item.productlink && (item.productlink.indexOf('EUREX') >= 0 || item.productName
                    .indexOf('香港') >= 0) && item.price != item.majorprice
                if (needJGChoose) {
                    if (this.jgChooseIndex == null) {
                        return this.$market.alert({
                            content: '请先在下方选择您的身份'
                        })
                    }
                    let selectEUREX = this.$refs.authTable.selectEUREX
                    let allJgData = this.authData.filter(v => (v.productlink.indexOf('EUREX') >= 0 || v.productName
                        .indexOf('香港') >= 0) && (v.majorprice != v.price))
                    console.log(allJgData, selectEUREX)
                    if (selectEUREX.length == allJgData
                        .length) { //selectEUREX.length == 1 && selectEUREX[0].id == item.id
                        this.jgselectShow = false
                    } else {
                        this.jgselectShow = true
                    }
                }
                next(item, index)
            },
            async chooseLimit (item) {
                if (item.selected) return
                if(item.value == 0) {
                    //按月购买
                    let agree = await new Promise((resolve)=>{
                        if (this.authData.filter(v=>!v.isMainAuth).length == 0) {
                            resolve()
                        } else {
                            let selections = this.memoryAuthSelections.length > 0 ? this.memoryAuthSelections : this.$refs.authTable.getSelections()
                            this.$market.agree({
                                content: `按月付费不能选配授权，你选配的${selections.map(v=>v.productName).join('、')}本次将被取消，请知晓！`,
                                agreeBtn: '我已知晓',
                                cancelBtn: '改为按年购买',
                                closeBtn: true,
                                agreeCall: ()=>{
                                    resolve()
                                },
                                degreeCall () {
                                    resolve('no')
                                }
                            })
                        }
                    })
                    if (agree == 'no') {
                        let by_year = this.deadLine.find(v => v.value == 1)
                        this.$nextTick(() => {
                            this.chooseLimit(by_year)
                        })
                    }
                    this.deadLine.forEach(v=>{
                        if(v.value == item.value) {
                            this.$set(v,'selected',true)
                        } else {
                            this.$set(v,'selected',false)
                        }
                    })
                    if (this.memoryAuthSelections.length <= 0) {
                        this.memoryAuthSelections = wh.disDeepClone(this.$refs.authTable.getSelections()/*.filter(v=> v.productName != "多账号下单模块")*/)//保存切换之前选中的授权项
                    }
                    this.orderByMonth(this.monthprice)
                    this.$refs.authTable.cancelEach(v=>/*v.productName != "多账号下单模块"*/true) //所有子授权取消选中
                    this.$refs.authTable.setDisableEach(v=>/*v.productName != "多账号下单模块"*/true)//所有子授权禁止选则
                        
                        
                } else if (item.value == 1) {
                    //按年购买
                        this.deadLine.forEach(v=>{
                            if(v.value == item.value) {
                                this.$set(v,'selected',true)
                            } else {
                                this.$set(v,'selected',false)
                            }
                        })
                    
                        this.orderByYear(this.price)
                        this.$refs.authTable.setDisableEach(v=>/*v.productName != "多账号下单模块"*/false)//所有子授权不禁止选则
                        if (this.memoryAuthSelections.length > 0) {  //如果之前有记录过的子授权，重新将其选中，并清除记录
                            this.memoryAuthSelections.forEach(item => {
                                this.$refs.authTable.selectItemByMemory(item)
                            })
                            //设置是否专业和是否机构
                            if (this.chooseIndex == 0) {
                                this.$refs.authTable.setUnMajorAll()
                            } else if (this.chooseIndex == 1) {
                                this.$refs.authTable.setMajorAll()
                            }

                            if (this.jgChooseIndex == 0) {
                                this.$refs.authTable.setNotJg()
                            } else if (this.jgChooseIndex == 1) {
                                this.$refs.authTable.setJg()
                            }
                        }
                } else if(item.value == 2) {
                    //按月购买
                    let agree = await new Promise((resolve)=>{
                        if (this.authData.filter(v=>!v.isMainAuth).length == 0) {
                            resolve()
                        } else {
                            let selections = this.memoryAuthSelections.length > 0 ? this.memoryAuthSelections : this.$refs.authTable.getSelections()
                            this.$market.agree({
                                content: `按季付费不能选配授权，你选配的${selections.map(v=>v.productName).join('、')}本次将被取消，请知晓！`,
                                agreeBtn: '我已知晓',
                                cancelBtn: '改为按年购买',
                                closeBtn: true,
                                agreeCall: ()=>{
                                    resolve()
                                },
                                degreeCall () {
                                    resolve('no')
                                }
                            })
                        }
                    })
                    if (agree == 'no') {
                        let by_year = this.deadLine.find(v => v.value == 1)
                        this.$nextTick(() => {
                            this.chooseLimit(by_year)
                        })
                    }
                    this.deadLine.forEach(v=>{
                        if(v.value == item.value) {
                            this.$set(v,'selected',true)
                        } else {
                            this.$set(v,'selected',false)
                        }
                    })
                    if (this.memoryAuthSelections.length <= 0) {
                        this.memoryAuthSelections = wh.disDeepClone(this.$refs.authTable.getSelections()/*.filter(v=> v.productName != "多账号下单模块")*/)//保存切换之前选中的授权项
                    }
                    this.orderByQuarter(this.quarterprice)
                    this.$refs.authTable.cancelEach(v=>/*v.productName != "多账号下单模块"*/true) //所有子授权取消选中
                    this.$refs.authTable.setDisableEach(v=>/*v.productName != "多账号下单模块"*/true)//所有子授权禁止选则
                        
                        
                }
            },
            hasOut() {
                console.log(this.$refs.authTable.hasOut)
                return this.showRenew ? this.$refs.authTable.hasOut : false
            },
            clear() {},
            fromWh10SetOnceUser (user) {
                triggerOnce(()=>{
                    //从wh10客户端来的界面，运行进程期间，只在第一次进入的时候触发设置user
                    this.user = user
                })
            }
        }
    }
</script>

<style scoped>
    .login_box {
        padding: 20px 0;
    }

    .forget_pwd {
        color: rgb(6, 96, 172);
        font-size: 12px;
        margin-left: 5px;
        position: relative;
        top: 5px;
    }

    .login_box .line {
        position: relative;
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        padding: 4px 0;
    }

    .login_box .line input {
        width: 95px;
        border: 1px solid rgb(202, 202, 203);
        background: white;
        margin: 0 3px;
        border-radius: 2px;
        height: 25px;
        line-height: 25px;
        outline: 0;
        padding-left: 10px;
    }

    .renew_box {
        padding-bottom: 20px;
    }

    .blue_btn {
        background: rgb(6, 96, 172);
        color: white;
        font-size: 12px;
        border: 0;
        border-radius: 3px;
        padding: 5px 10px;
        outline: 0;
    }

    .back_btn {
        color: rgb(60, 141, 237);
        text-decoration: underline;
        border: 0;
        background: transparent;
        cursor: pointer;
        padding-left: 20px;
        outline: none;
        background: url(../../assets/image/fanhui.png) no-repeat left;
        padding-left: 20px;
    }

    .tips {
        color: rgb(96, 69, 33);
    }

    .tips::before {
        content: '';
        width: 15px;
        height: 15px;
        display: inline-block;
        margin-right: 5px;
        background: url(../../assets/image/duicuo.png) no-repeat left center;
    }

    .arg_btn {
        background: transparent;
        border: 0;
        outline: 0;
    }

    .argument {
        color: #7c7c7c;
        max-height: 200px;
        height: 0;
        overflow: hidden;
        overflow-y: auto;
        background: #e0edfd;
        margin-bottom: 10px;
        transition: height .3s;
    }

    .argument.show {
        height: 200px;
    }

    .arg_btn {
        color: #1261D2;
        text-decoration: underline;
        cursor: pointer;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .selectItem {
        cursor: default;
    }

    .selectItem i {
        display: inline-block;
        width: 15px;
        height: 17px;
        vertical-align: middle;
        background: url(../../assets/image/choose_01_y.png) no-repeat center;
    }

    .selectItem.active i {
        background: url(../../assets/image/choose_01_y22.png) no-repeat center;
    }
    .little-label{
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
        padding: 0 0 4px;
        margin: 0;
    }
    
    .cut-line {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }
    
    .line-dot {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }
</style>